<template>
  <div>
    <div class="mb-2">
      <v-layout wrap>
        <v-flex xs11 style="align-self: center;">
          <date-filter
            v-model="selectedDate"
            @changeDate="onSelectedDate"
            :default-filter="'today'"
            :showTime="true"
          ></date-filter>
        </v-flex>
        <v-flex xs1 class="text-xs-right">
          <v-btn fab outline color="primary" @click="onRefresh" v-tooltip.top="$t('Refresh')" small>
            <i class="fa fa-refresh"></i>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="loading" class="text-xs-center" style="min-height: 400px">
      <v-layout justify-center align-center row style="height: 400px">
        <v-flex>
          <div class="spinner text-xs-center">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
        </v-flex>
      </v-layout>
    </div>
    <template v-else>
      <!-- <v-divider class="mt-3 mb-3"></v-divider> -->

      <v-layout wrap>
           <v-flex sm9 xs12> </v-flex>
        <v-flex sm3 md3 class="px-1 text-xs-right"> </v-flex>
        <v-flex xs12 sm6 md3 class="form-control px-1" style="display: inherit;">
          <div class="input-icons">
            <i class="fa fa-search icon"></i>
            <input
              @keyup.enter="
                pageNumber = 1
                getIntent()
              "
              type="text"
              v-model="search"
              class="form-control"
              :placeholder="$t('Search Conversation Name')"
              style="margin-bottom: 10px"
            />
            <v-btn v-show="search.length > 0" @click="clearSearch" icon class="icon-close">
              <i class="fa fa-close"></i
            ></v-btn>
          </div>
          <v-btn @click="onSelectedDate" color="primary">
            {{ $t('Search') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <template v-if="filterSummary.length > 0">
        <v-layout>
          <v-flex sm6> </v-flex>
          <v-spacer />
          <v-flex xs6 class="text-xs-right text-sm-right">
            <v-pagination
              v-model="pageNumber"
              :length="pageCount"
              @input="onClickPageinate"
              class="mb-2"
            ></v-pagination>
          </v-flex>
        </v-layout>
        <template v-for="(order, index) in filterSummary">
          <div :key="`${order}_${index}`" class="z-border-red" style="margin-bottom: 10px;">
            <v-layout>
              <v-flex>
                <div class="ma-2">Order Number: {{ order.orderNumber }}</div>
              </v-flex>
              <v-flex> </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout wrap fill-height>
              <v-flex xs12 sm7>
                <div style="border-right: 1px solid #eee; height: 100%">
                  <line-my-shop-order-detail
                    v-model="order.orderNumber"
                  ></line-my-shop-order-detail>
                  <div>
                    <v-layout>
                      <v-flex>
                        <div class="pa-2">{{ $t('Subtotal') }}:</div>
                      </v-flex>
                      <v-flex>
                        <div class="pa-2 text-xs-right">
                          <span class="primary-color"
                            >฿{{ order.subtotalPrice | decimalFormat }}</span
                          >
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex>
                        <div class="pa-2">{{ $t('Shipping fee') }}:</div>
                      </v-flex>
                      <v-flex>
                        <div class="pa-2 text-xs-right">
                          <span class="primary-color"
                            >฿{{ order.shipmentPrice | decimalFormat }}</span
                          >
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex>
                        <div class="pa-2">{{ $t('Discount') }}:</div>
                      </v-flex>
                      <v-flex>
                        <div class="pa-2 text-xs-right">
                          <span class="primary-color"
                            >-฿{{ order.discountAmount | decimalFormat }}</span
                          >
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex>
                        <div class="pa-2">{{ $t('Total') }}:</div>
                      </v-flex>
                      <v-flex>
                        <div class="pa-2 text-xs-right">
                          <span class="primary-color">฿{{ order.totalPrice | decimalFormat }}</span>
                        </div>
                      </v-flex>
                    </v-layout>
                  </div>
                  <v-divider />

                  <div class="pa-2">
                    <img
                      v-if="order.shipmentDetail == 'normal'"
                      src="/static/img/assets/payment/normal_charge_logo.png"
                      alt
                      class="responsive-img"
                      style="max-height: 50px"
                    />
                    <img
                      v-else-if="order.shipmentDetail == 'ems'"
                      src="/static/img/assets/payment/ems_charge_logo.png"
                      alt
                      class="responsive-img"
                      style="max-height: 50px"
                    />
                    <img
                      v-else-if="order.shipmentDetail == 'kerry'"
                      src="/static/img/assets/payment/kerry_charge_logo.png"
                      alt
                      class="responsive-img"
                      style="max-height: 50px"
                    />
                    <template v-else>
                      <template v-if="order.shipmentDetail">
                        <img
                          :src="'/static/img/assets/payment/' + order.shipmentDetail + '_logo.png'"
                          alt
                          class="responsive-img"
                          style="max-height: 50px"
                        />
                        <div v-if="order.shipmentDetail == 'cod_charge'" class="caption">
                          {{ $t('cod_charge') }}
                        </div>
                      </template>
                    </template>
                  </div>
                  <div class="ml-2">{{ $t(order.shipmentDetail) }}</div>

                  <div class="pa-2">
                    <!-- <multiselect
                          :key="order.id + '_bankname'"
                          v-model="bankname"
                          :options="monobobanklist"
                          label="text"
                          selectLabel
                          selectedLabel
                          :allow-empty="false"
                          :searchable="false"
                          deselect-label
                          track-by="text"
                          @select="onSelectBank"
                        ></multiselect> -->
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 sm5>
                <div style="word-break: break-word;" class="pa-2">
                  <div class="caption">{{ $t('Address') }}</div>
                  <span>{{
                    `${order.shippingAddress.recipientName} ${order.shippingAddress.address} ${order.shippingAddress.province} ${order.shippingAddress.postalCode} ${order.shippingAddress.email} ${order.shippingAddress.phoneNumber}`
                  }}</span>
                  <div class="caption mt-3">{{ $t('Status') }}</div>
                  <div class="primary--text">
                    {{ order.paymentStatus ? $t(order.paymentStatus) : '-' }}
                  </div>
                </div>
                <v-divider></v-divider>

                <div class="pa-2">
                  <template>
                    Tracking number : {{ order.shipmentDetail.trackingNumber || '-' }}
                  </template>
                </div>

                <v-layout>
                  <v-flex>
                    <div class="pa-2">
                      <div>
                        <template v-if="order.shipmentDetail.isCod">
                          {{ $t('cod_charge') }}
                        </template>
                        <template v-else>
                          {{ order.shipmentDetail.paymentMethod }}
                        </template>
                      </div>
                      {{ order.checkoutAt | DateFormat('DD/MM/YYYY HH:mm') }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <template>
              <div class="hr"></div>
            </template>
          </div>
        </template>
        <div class="text-xs-right" style="padding-top: 10px">
          <v-pagination
            v-model="pageNumber"
            :length="pageCount"
            @input="onClickPageinate"
            class="mb-2"
          ></v-pagination>
        </div>
      </template>
      <template v-else>
        <div class="text-xs-center" style="margin: 35px 0">
          <img
            src="/static/img/assets/ecommerce/empty_shopping_cart.png"
            alt
            style="width: 230px"
          />
          <h2>{{ $t('No data') }}</h2>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DateFilter from '@/components/view/analytics/DateFilter'
import LineMyShopOrderDetail from './LineMyShopOrderDetail'
import dayjs from 'dayjs'

export default {
  data: function() {
    return {
      isTracking: false,
      checkboxAll: false,
      cbAll: [],
      pageCount: 0,
      filterSummary: [],
      selectedDate: {
        start: dayjs().format('YYYY-MM-DD 00:00'),
        end: dayjs().format('YYYY-MM-DD 23:59')
      },
      search: '',
      loading: false,
      pageNumber: 1
    }
  },
  components: {
    DateFilter,
    LineMyShopOrderDetail
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      currentLang: 'currentLang'
    })
  },
  async mounted() {
    const vm = this
    vm.getOrderSummary()
  },

  methods: {
    clickCbAll() {
      if (!this.cbAll.length) {
        this.cbAll = this.filterSummary.map(v => v.id)
        this.checkboxAll = true
      } else {
        this.cbAll = []
        this.checkboxAll = false
      }
    },
    clearSearch() {
      const vm = this
      vm.search = ''
      vm.getOrderSummary()
    },
    onClickPageinate: function(pageNum) {
      $('.vb-content').animate({
        scrollTop: 0
      })
    },
    async getOrderSummary() {
      const vm = this
      vm.loading = true
      const data = {
        pageid: vm.selectedBot.pageid,
        body: {
          page: vm.pageNumber,
          startAt: dayjs(vm.selectedDate.start).format('YYYY-MM-DDTHH:mm:ss[Z]'),
          endAt: dayjs(vm.selectedDate.end).format('YYYY-MM-DDTHH:mm:ss[Z]'),
          search: vm.search
        }
      }
      let response = await this.get(`line-my-shop/${data.pageid}/orders`, {
        params: data.body
      })
      if (response.success) {
        vm.pageCount = response.result.totalPage
        vm.pageNumber = response.result.currentPage
        vm.filterSummary = response.result.data
      }
      vm.loading = false
    },
    onSelectedDate: async function() {
      const vm = this
      vm.pageNumber = 1
      vm.loading = true
      await vm.getOrderSummary()
      vm.loading = false
    },
    async onRefresh() {
      const vm = this
      vm.loading = true
      await vm.getOrderSummary()
      vm.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.input-icons {
  display: contents;
  i {
    position: absolute;
  }
  .icon-close {
    color: gray;
    padding: 16px;
    margin-left: -40px;
  }
  .icon {
    padding: 16px;
    min-width: 50px;
  }
  input {
    padding-left: 35px !important;
    padding-right: 35px !important;
    width: 100%;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/LineMyShopSummary.vue